import { useSetRecoilState } from "recoil"

import { panState, zoomState } from "~/containers/LegacyDesigner/state/view"

export const useResetZoomAndPan = (): (() => void) => {
  const setZoom = useSetRecoilState(zoomState)
  const setPan = useSetRecoilState(panState)

  return () => {
    setZoom(100)
    setPan({ x: 0, y: 0 })
  }
}
